import { Injectable } from '@angular/core';

@Injectable()
export default class ValidationRulesService {

  public addInputError(selectorId: any, errorMsg: any): void {
    const input = document.getElementById(selectorId);
    const formInput = input.closest('.form-input');
    const error = formInput.querySelector('.error-wrapper');
    const visibleError = formInput.querySelector('.error-wrapper > .additional-error');
    const small = document.createElement('small');
    small.setAttribute('role', 'alert');
    small.classList.add('form-message', 'additional-error');
    small.innerHTML = errorMsg;

    if (visibleError) {
      visibleError.remove();
    }

    error.appendChild(small);
  }
}
